// extracted by mini-css-extract-plugin
export var deliveryRow = "_rk-a";
export var fixedHeight = "_rk-4";
export var freightLogo = "_rk-9";
export var fullWidth = "_rk-3";
export var priceColumn = "_rk-5";
export var radioSelected = "_rk-7";
export var radioUnselected = "_rk-6";
export var selectedOption = "_rk-2";
export var selectedOptionContainer = "_rk-1";
export var selection = "_rk-0";
export var tallSkeletonText = "_rk-8";